import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import AttachFilesProjectEvaluationWidget from '../../../widgets/projectEvaluationProgress/AttachFilesProjectEvaluationWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProjectEvaluationProgress } from '../../../redux/actions/attachments'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ProjectEvaluationProgress() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectEvaluationProgress(projectId)
      console.log('AttachFilesView => ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load AttachFilesView projectId', projectId)
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  console.log(schema?.forms?.projectProgressReport)
  console.log(schema?.forms?.projectEvaluationReport)

  return (
    <>
      <SidebarProposal statusDefault={1}>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {schema?.forms?.projectProgressReport && (
          <>
            <AttachFilesProjectEvaluationWidget
              showCommandButton={true}
              isEdit={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
              }
              schema={schema?.forms?.projectProgressReport}
              handleGetSchema={handleGetSchema}
            />
            <br />
          </>
        )}
        {schema?.forms?.projectEvaluationReport && (
          <>
            <AttachFilesProjectEvaluationWidget
              handleGetSchema={handleGetSchema}
              showCommandButton={true}
              isEdit={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
              }
              schema={schema?.forms?.projectEvaluationReport}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
